import { FetchClient } from '@foundatiofx/fetchclient';

export type TimeZoneList = {
    timeZones: { id: string; displayName: string }[];
};

export type Role = {
    name: string;
    description: string;
    impliedRoles: string[];
    isGlobalOnly: boolean;
};

export type RoleList = {
    roles: Role[];
};

export class SystemApi {
    constructor(
        private fetch = new FetchClient(),
        private route = 'system/'
    ) {}

    async getTimeZones() {
        return await this.fetch.getJSON<TimeZoneList>(this.route + 'timezones');
    }

    async getRoles() {
        return await this.fetch.getJSON<RoleList>(this.route + 'roles');
    }
}
